import { useEffect } from 'react';
import DeepResultSample from '@components/common/deepResultSample';
import { useEventsParticipationStatus } from '@repository/event/useEvent';
import { useUserInfo } from '@repository/auth/useUserInfo';
import { useResultStore } from '@components/acca/results/result/resultStoreProvider';
import V3Result from '../applyResult/v3Result';
import { EventTypeEnum } from '@domain/constant/event/EventType';
import useCheckAuthority from '@utils/hooks/useCheckAuthority';

const DeepResult = () => {
  const { isPublicStore, accaResultStore } = useResultStore();
  const { data: userInfo } = useUserInfo();
  const { data: participationStatus } = useEventsParticipationStatus(EventTypeEnum.TALENT_POOL_HOLIDAY_2023_10);
  const { isAuthorityUser } = useCheckAuthority(userInfo);

  const { accResultSn, fetchAccCompetenceProfile, fetchAccCompetenceCurationCompany, fetchAccCompetenceCurationJob } =
    accaResultStore;

  useEffect(() => {
    initAccCompetency();
  }, [userInfo, accResultSn]);

  const initAccCompetency = () => {
    if (accResultSn === null) return;
    if (!isPublicStore && !isAuthorityUser) return;
    fetchAccCompetenceProfile();
    fetchAccCompetenceCurationCompany();
    fetchAccCompetenceCurationJob();
  };

  //이벤트 참여 & 이벤트 종료 안됐을 경우
  const isParticipation = participationStatus?.isParticipation && !participationStatus.isEnded;

  // 제휴서비스 신청 안 했을 경우
  if (!isParticipation && !isPublicStore && !isAuthorityUser) return <DeepResultSample />;

  return <V3Result requestPage={'deep'} />;
};

export default DeepResult;
